import React from "react";

const Card = ({ title, bgColor, titleFontSize, imageSrc }) => {
  const isLightBackground = bgColor === "#FFFFFF";

  const cardStyle = {
    backgroundColor: bgColor,
    padding: "2rem",
    width: "100%",
    boxSizing: "border-box",
  };

  const titleStyle = {
    fontSize: titleFontSize,
    fontWeight: "bold",
    color: isLightBackground ? "black" : "white",
    margin: "0",
    textAlign: "left",
    whiteSpace: "pre-wrap"
  };

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    justifyContent: "flex-start",
    marginLeft: "2vw",
    gap: "5%",
  };

  const imageStyle = {
    width: "10vh",
    height: "10vh",
    borderRadius: "50%",
    flex: "0 0 auto",
  };

  return (
    <div style={cardStyle} className="card">
      <style>
        {`
            @media (max-width: 768px) {
            .card .container {
              flex-direction: column;
              align-items: flex-start;
              gap: 1rem;
              margin-left: 0;
            }
          }
        `}
      </style>
      <div className="container" style={containerStyle}>
        <h2 style={titleStyle}>{title}</h2>
        {imageSrc && (
          <span className="ml-4">
            <img src={imageSrc} alt="Card Image" style={imageStyle} />
          </span>
        )}
      </div>
    </div>
  );
};

const Partner = () => {
  return (
    <div className="flex flex-wrap justify-center">
      <Card
        title="Community Branchs&nbsp;&nbsp;"
        bgColor="#6366f1"
        titleFontSize="2vw"
        imageSrc="/image/comun/icikiwirlogo.webp"
      />
      <Card
        title="Active Event Partners"
        bgColor="#FFFFFF"
        titleFontSize="2vw"
        imageSrc="/image/comun/regalien.jpg"
      />
      <Card
        title="Past Event Partners&nbsp;&nbsp;&nbsp;"
        bgColor="#6366f1"
        titleFontSize="2vw"
        imageSrc="/image/comun/icikiwirlogo.webp"
      />
      <Card
        title="Community Sponsor&nbsp;"
        bgColor="#FFFFFF"
        titleFontSize="2vw"
        imageSrc="/image/comun/icikiwirlogo.webp"
      />
      <Card
        title="Community Partners"
        bgColor="#6366f1"
        titleFontSize="2vw"
        imageSrc="/image/comun/icikiwirlogo.webp"
      />
    </div>
  );
};

export default Partner;
